import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lightbulb",
  "use": "Lightbulb-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"Lightbulb\">\n\t<path d=\"M11.8 28.6c0 .7.6 1.4 1.4 1.4h5.6c.8 0 1.4-.7 1.4-1.4v-1.4h-8.4v1.4zM16 2c-5.5 0-9.8 4.3-9.8 9.8 0 3.4 1.7 6.3 4.2 8V23c0 .7.6 1.4 1.4 1.4h8.4c.8 0 1.4-.7 1.4-1.4v-3.2c2.5-1.8 4.2-4.8 4.2-8C25.8 6.3 21.5 2 16 2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol